import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="components--drawer"
export default class extends Controller {
  static get targets() {
    return ['currentDiv'];
  }

  connect() {
    if (window.$) {
      window.$(this.element).modal('show');
      window.$(this.element).on('hidden.bs.modal', () => this.hideDrawer());

      this.scrollToCurrentDiv();
    }
  }

  hideDrawer() {
    const turboFrame = this.element.closest('turbo-frame');

    if (turboFrame) {
      turboFrame.innerHTML = '';
    } else {
      this.element.remove();
    }
  }

  scrollToCurrentDiv() {
    if (this.hasCurrentDivTarget) {
      this.currentDivTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }

  currentDivTargetConnected() {
    this.scrollToCurrentDiv();
  }
}
